import { useQuery } from '@apollo/client';
import { useState } from 'react';

import query from './query.graphql';

function isImpersonatingUser(email: string) {
  const impersonationCookie = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`clearbit.last_impersonation_admin=`));

  if (!impersonationCookie) {
    return false;
  }

  const adminEmail = decodeURIComponent(impersonationCookie.split('=')[1]);

  return email !== adminEmail;
}

export default function ImpersonationWarning() {
  const [isImpersonated, setIsImpersonated] = useState<boolean>(false);
  const { loading } = useQuery(query, {
    onCompleted: ({ viewer }) => {
      setIsImpersonated(isImpersonatingUser(viewer.user.email));
    },
  });

  if (loading || !isImpersonated) {
    return null;
  }

  return (
    <div className="absolute top-0 left-0 right-0 z-50 p-1 text-center text-white bg-red-400 h-7">
      Warning: Logged in with a customer account. Use your powers wisely.
      <a
        className="ml-2 font-semibold text-white underline"
        href="/logout?impersonation=true"
      >
        Sign out of customer account
      </a>
    </div>
  );
}
